import { useAxios } from "../useAxios"

export const useSaveFiltersRequest = () => {
    const { sendRequest } = useAxios()

    const route = '/saved-filters'

    //GET
    const getSavedFilters = () => {
        return sendRequest({
            slug: 'saveFilter',
            url: `${route}`,
            method: 'GET',
        })
    }


    //POST
    const saveFilters = (payload: any) => {
        return sendRequest({
            slug: 'saveFilter',
            url: `${route}`,
            method: 'POST',
            payload
        })
    }

    //DELETE
    const removeFilters = (filter: any) => {
        return sendRequest({
            slug: 'removeFilter',
            url: `${route}/${filter._id}`,
            method: 'DELETE',
            displayToast: false,
            all: true
        })
    }

    return {
        getSavedFilters,
        saveFilters,
        removeFilters
    }
}